<div class="participantDisplay">
	<div class="participantType">
		<mat-icon class="secondary" fontIcon="fa-user-graduate" fontSet="fas" inline />
	</div>
	<div class="info">
		<span class="secondary">{{ studentName() }}</span>
		@if (studentEmail()) {
			<span>{{ studentEmail() }}</span>
		}
	</div>
</div>

<ng-content />

@if (hasClinicalVignette()) {
	<sim-button
		variant="stroked"
		color="accent"
		(onClick)="onShowClinicalVignette.emit()"
		[label]="T.EXAMINER_ASSESSMENT_DISPLAY_SHOW_CLINICAL_VIGNETTE | translate"
		[icon]="{
			fontSet: 'fas',
			fontIcon: 'fa-file-medical-alt',
		}"
	/>
}
